import React from "react";
import {
  Box,
  Heading,
  VStack,
  Text as CText,
  NumberInput,
  NumberInputField,
  Select,
  HStack,
  Input,
} from "@chakra-ui/react";

export default function Inspector({
  sel,
  pxLayout,
  layout,
  viewW,
  viewH,
  updateSelectedField,
  updateSelectedFontSizePx,
  currentFontSizePx,
  currentWeight,
  updateSelectedWeight,
  currentColor,
  updateSelectedColor,
}) {
  if (!sel) {
    return (
      <Box opacity={0.75}>
        Chọn một khung để chỉnh
      </Box>
    );
  }

  const isAvatar = sel === "avatar";

  return (
    <Box>
      {/* <Heading size="sm" mb={3}>
        Trình kiểm tra
      </Heading> */}

      {/* ==================== AVATAR ==================== */}
      {isAvatar ? (
        <VStack align="stretch" spacing={2}>
          <CText fontWeight="semibold">Avatar</CText>

          {/* <NumberInput
            value={pxLayout?.avatar?.cx ?? 0}
            min={0}
            max={viewW}
            onChange={(_, n) => updateSelectedField("cx", n)}
          >
            <NumberInputField placeholder="center x (px)" />
          </NumberInput>

          <NumberInput
            value={pxLayout?.avatar?.cy ?? 0}
            min={0}
            max={viewH}
            onChange={(_, n) => updateSelectedField("cy", n)}
          >
            <NumberInputField placeholder="center y (px)" />
          </NumberInput>

          <NumberInput
            value={pxLayout?.avatar?.d ?? 0}
            min={10}
            max={Math.max(viewW, viewH)}
            onChange={(_, n) => updateSelectedField("d", n)}
          >
            <NumberInputField placeholder="diameter (px)" />
          </NumberInput> */}
        </VStack>
      ) : (
        /* ==================== TEXT FIELDS ==================== */
        <VStack align="stretch" spacing={2}>
          <CText fontWeight="semibold" textTransform="capitalize">
            {sel}
          </CText>

          {/* <NumberInput
            value={pxLayout?.[sel]?.x ?? 0}
            min={0}
            max={viewW}
            onChange={(_, n) => updateSelectedField("x", n)}
          >
            <NumberInputField placeholder="center x (px)" />
          </NumberInput>

          <NumberInput
            value={pxLayout?.[sel]?.y ?? 0}
            min={0}
            max={viewH}
            onChange={(_, n) => updateSelectedField("y", n)}
          >
            <NumberInputField placeholder="center y (px)" />
          </NumberInput>

          <NumberInput
            value={pxLayout?.[sel]?.w ?? 0}
            min={10}
            max={viewW}
            onChange={(_, n) => updateSelectedField("w", n)}
          >
            <NumberInputField placeholder="width (px)" />
          </NumberInput>

          <NumberInput
            value={pxLayout?.[sel]?.h ?? 0}
            min={10}
            max={viewH}
            onChange={(_, n) => updateSelectedField("h", n)}
          >
            <NumberInputField placeholder="height (px)" />
          </NumberInput> */}

          {/* FONT SIZE */}
          <CText mt={2} fontSize="sm" opacity={0.8}>
            Font size (px)
          </CText>
          <NumberInput
            value={currentFontSizePx || 0}
            min={4}
            max={2000}
            onChange={(_, n) =>
              Number.isFinite(n) && updateSelectedFontSizePx(n)
            }
          >
            <NumberInputField placeholder="font size (px)" />
          </NumberInput>

          {/* FONT WEIGHT */}
          <CText mt={2} fontSize="sm" opacity={0.8}>
            Font weight
          </CText>
          <Select
            value={String(currentWeight)}
            onChange={(e) => updateSelectedWeight(Number(e.target.value))}
          >
            <option value="400">400 - Regular</option>
            <option value="600">600 - Medium</option>
            <option value="700">700 - Bold</option>
            <option value="800">800 - ExtraBold</option>
          </Select>

          {/* COLOR */}
          <CText mt={2} fontSize="sm" opacity={0.8}>
            Color
          </CText>
          <HStack>
            <Box
              as="input"
              type="color"
              value={currentColor}
              onChange={(e) => updateSelectedColor(e.target.value)}
              w="48px"
              h="40px"
              p="0"
              border="1px solid #444"
              borderRadius="md"
            />
            <Input
              value={currentColor}
              onChange={(e) => updateSelectedColor(e.target.value)}
              placeholder="#RRGGBB"
            />
          </HStack>

          <CText fontSize="xs" opacity={0.6}>
            Font size = <code>0.72 × height</code>
          </CText>
        </VStack>
      )}
    </Box>
  );
}
